import { HttpErrorResponse } from '@angular/common/http';

import {
  BillingEstimate,
  BillingEstimateAddonsParams,
  BillingEstimateParams,
} from '@recruitee/http/types';
import { createSingleEntityStore, PickActions, pipeState } from '@recruitee/ngrx';

const { actions, namespace, reducer, selectors } = createSingleEntityStore<BillingEstimate>()(
  'BillingEstimate',
  {
    customActions: adapter => ({
      fetch: (state, payload: BillingEstimateParams) =>
        pipeState(adapter.reset(), next => adapter.markAsPending(next)),

      fetchAddons: (state, payload: BillingEstimateAddonsParams) =>
        pipeState(adapter.reset(), next => adapter.markAsPending(next)),
      fetchAddonsSuccess: (state, payload: { data: any }) =>
        pipeState(
          state,
          next => adapter.save(next, payload.data),
          next => adapter.markAsLoaded(next),
        ),
      fetchAddonsFailed: (state, payload: { error: HttpErrorResponse }) =>
        pipeState(adapter.reset(), next => adapter.setError(next, payload.error)),
    }),
  },
);

const BillingEstimateActions: PickActions<typeof actions, 'fetch' | 'fetchAddons'> = actions;

export {
  BillingEstimateActions,
  namespace as BillingEstimateNamespace,
  reducer as BillingEstimateReducer,
  selectors as BillingEstimateSelectors,
};
